import React, { useContext, useState, memo, useEffect, useRef } from 'react';
import { AppStore } from "../App/App.Store";
import "./Candidates.scss"
import { Service } from '../App/App.Service';
import queryString from "querystring";

const Candidates = () => {
  const {
    setPopup
  } = useContext(AppStore);

  useEffect(() => {
    let parse = queryString.parse(window.location.search);
    if (parse["?showTnx"] == 1) {
      setPopup(-1);
    }
  }, [])

  return (
    <section className="section section-candi">
      <div className="padding">
        <div className="container">
          {(() => Service.getItems().map((item, index) => <div className="item" key={index} onClick={() => {
            setPopup(index);
          }}>
            <div className={`image image-${item.image}`}>
              <div className="title">
                <div className="text">
                  {item.Product}
                  <div className="greentext">
                    לחץ לפרטים נוספים
                  </div>
                </div>
                <div className="arrow"></div>
              </div>
            </div>
            <div className="desc">{item.School}</div>
          </div>))()}
        </div>
      </div>
    </section>)
}

export default memo(Candidates);


// WEBPACK FOOTER //
// ./src/Components/Candidates/Candidates.jsx